import styled from '@emotion/styled';

export const MapContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0rem;
`;

export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	@media screen and (max-width: 900px) {
		& > * {
			padding: 0 2rem;
		}
		& > :last-child {
			padding: 0 0rem;
		}
	}
`;
export const ContentTitle = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 140%;
	letter-spacing: -0.6px;
`;
export const MapsContent = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
`;
export const MapsContentSubContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.8rem;
	@media screen and (max-width: 900px) {
		display: flex;
		flex-direction: column;
		gap: 0.4rem;
	}
`;
export const ImgMapBox = styled.div`
	height: 40rem;
`;
export const MapBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	width: 100%;
	padding: 2rem;
	background-color: #f1f3f5;
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
`;
export const MapContent = styled.div`
	display: flex;
	flex-direction: column;
	padding-bottom: 2rem;
	border-bottom: 1px solid #dee2e6;
	gap: 0.8rem;
	:last-child {
		padding-bottom: 0;
		border-bottom: none;
	}
	.menu_box {
		display: flex;
		align-items: center;
		background-color: ${(props) => props.theme.colors.primary400};
		color: #fff;
		border-radius: 999.9rem;
		padding: 0.4rem 1.2rem;
		font-size: ${(props) => props.theme.fontSize.sizeLg};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: 130%;
		letter-spacing: -0.6px;
		width: fit-content;
	}
	.menu_box_list {
	}
`;
